export default {"src":"/_next/static/media/trophy-icon.cedbd8c4.svg","height":39,"width":39};